import React, { useState } from 'react';
import {
	Box,
	Grid,
	Autocomplete,
	TextField,
	Button,
	Container,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import {
	setSelectedArrival,
	setSelectedDepart,
} from '../../reducers/UiReducer';
import {
	AddSearchFlightDispatch,
	fetchCityDispatch,
} from '../../reducers/HomeReducer';
import { DatePicker, Space } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import moment from 'moment';
const { RangePicker } = DatePicker;

const ModifyHotel = () => {
	const { city } = useSelector((state) => state.home);
	const { depart, arrival } = useSelector((state) => state.ui);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const [adult, setAdult] = useState(1);
	const [child, setChild] = useState(0);
	const [infant, setInfant] = useState(0);
	const [departDateReturn, setDepartDateReturn] = useState('');
	const [departDate, setDepartDate] = useState('');
	const [loadings, setLoading] = useState(false);
	const [open, setOpen] = useState(false);
	const handleChange = (event) => {
		let value = event.target.value.toLowerCase();
		let cityData = {
			keywords: value,
			limits: 10,
		};
		dispatch(fetchCityDispatch(cityData));
	};
	const onChange = (date, dateString) => {
		setDepartDate(dateString);
	};
	const onChangeReturn = (date, dateString) => {
		setDepartDateReturn(dateString);
	};
	function disabledDate(current) {
		// Can not select days before today and today
		return current && current < moment().endOf('day');
	}
	const showModal = () => {
		setOpen(true);
	};
	const handleOk = () => {
		setLoading(true);
		setTimeout(() => {
			setLoading(false);
			setOpen(false);
		}, 3000);
	};

	const handleCancel = () => {
		setOpen(false);
	};
	const handleSearch = () => {
		let formData = {
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			DirectFlight: false,
			OneStopFlight: false,
			JourneyType: 1,
			PreferredAirlines: null,
			Segments: [
				{
					Origin: depart.airport_code,
					Destination: arrival.airport_code,
					FlightCabinClass: 1,
					PreferredDepartureTime: departDate,
				},
			],
			Sources: 'WEB',
			agent_id: 0,
		};
		let formData2 = {
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			DirectFlight: false,
			OneStopFlight: false,
			JourneyType: 2,
			PreferredAirlines: null,
			Segments: [
				{
					Origin: depart.airport_code,
					Destination: arrival.airport_code,
					FlightCabinClass: 1,
					PreferredDepartureTime: departDateReturn[0],
				},
				{
					Origin: arrival.airport_code,
					Destination: depart.airport_code,
					FlightCabinClass: 1,
					PreferredDepartureTime: departDateReturn[1],
				},
			],
			Sources: 'WEB',
			agent_id: 0,
		};
		if (location.state.JourneyType === 1) {
			navigate('/searchresult', { state: formData });
			dispatch(AddSearchFlightDispatch(formData, navigate));
		} else {
			navigate(
				depart.country_code === 'IN' && arrival.country_code === 'IN'
					? '/searchresultroundtrip'
					: '/searchresultinternational',
				{ state: formData2 }
			);
			dispatch(AddSearchFlightDispatch(formData2, navigate));
		}
	};
	return (
		<div>
			{' '}
			<Box style={{ background: '#721053' }}>
				<Container>
					<Box
						style={{
							// paddingLeft: 100,
							// paddingRight: 100,
							paddingTop: 1,
							paddingBottom: 1,
						}}>
						<Grid container spacing={2} alignItems={'center'}>
							<Grid item xs={12} lg={location.state.JourneyType === 2 ? 2 : 3}>
								<Autocomplete
									id='country-select-demo'
									sx={{
										width: '100%',
										'& .MuiInputBase-input': {
											color: 'white',
										},
									}}
									options={city && city.result.length > 0 ? city.result : []}
									autoHighlight
									ListboxProps={{
										className: 'myCustomList',
									}}
									value={depart}
									getOptionLabel={(option) =>
										`${option.airport_code}- ${option.city_name} `
									}
									renderOption={(props, option) => (
										<Box
											component='li'
											sx={{ '& > img': { mr: 2, flexShrink: 0, fontSize: 14 } }}
											{...props}>
											<img
												loading='lazy'
												width='20'
												src={`https://flagcdn.com/w20/${option.country_code.toLowerCase()}.png`}
												srcSet={`https://flagcdn.com/w40/${option.country_code.toLowerCase()}.png 2x`}
												alt=''
											/>
											<p style={{ fontSize: 14, marginLeft: 5 }}>
												{option.city_name} - {option.airport_code}
											</p>
										</Box>
									)}
									onChange={(event, value) => {
										dispatch(setSelectedDepart(value));
									}}
									renderInput={(params) => (
										<TextField
											{...params}
											id='standard-basic'
											variant='standard'
											onChange={handleChange}
											style={{ fontSize: 12, borderBottom: '1px solid white' }}
											inputProps={{
												...params.inputProps,
												autoComplete: 'new-password', // disable autocomplete and autofill
											}}
										/>
									)}
								/>
							</Grid>
							<Grid item xs={12} lg={4} className='result'>
								<RangePicker
									disabledDate={disabledDate}
									onChange={onChangeReturn}
									style={{
										width: '100%',
										padding: 8,
										background: '#721053',
										border: '1px solid #721053',
										color: 'white',
										boxShadow: 'none',
									}}
								/>
							</Grid>{' '}
							<Grid item xs={12} lg={2}>
								<Button
									onClick={showModal}
									style={{
										textTransform: 'capitalize',
										padding: 7,
										borderBottom: '1px solid white',
										width: '100%',
										height: 'auto',
										color: 'white',
										borderRadius: 2,
									}}>
									Traveller Class
								</Button>{' '}
								<Modal
									open={open}
									title='Travellers'
									onOk={handleOk}
									onCancel={handleCancel}
									footer={[
										<Button key='back' onClick={handleCancel}>
											OK
										</Button>,
									]}>
									<Box
										style={{
											display: 'flex',
											justifyContent: 'space-between',
										}}>
										<p>Adults(12+yrs)</p>
										<Box>
											<Button
												onClick={() => (adult === 0 ? '' : setAdult(adult - 1))}
												style={{
													fontSize: 14,
													background: 'orange',
													color: 'white',
													fontWeight: 'bold',
												}}>
												--
											</Button>
											<Button
												style={{
													fontSize: 14,
													background: 'white',
													fontWeight: 'bold',
												}}>
												{adult}
											</Button>
											<Button
												onClick={() =>
													adult + child + infant === 9
														? adult
														: setAdult(adult + 1)
												}
												style={{
													fontSize: 14,
													background: 'orange',
													color: 'white',
													fontWeight: 'bold',
												}}>
												+
											</Button>
										</Box>
									</Box>
									<Box
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											marginTop: 5,
										}}>
										<p>Child(2-11yrs)</p>
										<Box>
											<Button
												onClick={() => (child === 0 ? '' : setChild(child - 1))}
												style={{
													fontSize: 14,
													background: 'orange',
													color: 'white',
													fontWeight: 'bold',
												}}>
												--
											</Button>
											<Button
												style={{
													fontSize: 14,
													background: 'white',
													fontWeight: 'bold',
												}}>
												{child}
											</Button>
											<Button
												onClick={() =>
													adult + child + infant === 9
														? child
														: setChild(child + 1)
												}
												style={{
													fontSize: 14,
													background: 'orange',
													color: 'white',
													fontWeight: 'bold',
												}}>
												+
											</Button>
										</Box>
									</Box>
									<Box
										style={{
											display: 'flex',
											justifyContent: 'space-between',
											marginTop: 5,
										}}>
										<p>Infant(0-2yrs)</p>
										<Box>
											<Button
												onClick={() =>
													infant === 0 ? '' : setInfant(infant - 1)
												}
												style={{
													fontSize: 14,
													background: 'orange',
													color: 'white',
													fontWeight: 'bold',
												}}>
												--
											</Button>
											<Button
												style={{
													fontSize: 14,
													background: 'white',
													fontWeight: 'bold',
												}}>
												{infant}
											</Button>
											<Button
												onClick={() =>
													adult + child + infant === 9
														? infant
														: setInfant(infant + 1)
												}
												style={{
													fontSize: 14,
													background: 'orange',
													color: 'white',
													fontWeight: 'bold',
												}}>
												+
											</Button>
										</Box>
									</Box>
								</Modal>
							</Grid>
							<Grid item xs={12} lg={2}>
								<Button
									onClick={handleSearch}
									style={{
										background: '#EC5B24',
										color: 'white',
										width: '100%',
										padding: 6,
										height: 'auto',
									}}>
									Search
								</Button>
							</Grid>
						</Grid>
					</Box>
				</Container>
			</Box>
		</div>
	);
};

export default ModifyHotel;
